'use strict';

var fadeIn = "\n&.fadeIn {\n  opacity: 0;\n  visibility: visible;\n  animation: fadeIn 0.3s both;\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translate3d(0, -20%, 0);\n    }\n    to {\n      opacity: 1;\n      transform: translate3d(0, 0, 0);\n    }\n  }\n}\n";

var fadeOut = "\n&.fadeOut {\n  visibility: visible;\n  opacity: 1;\n  animation: fadeOut 0.3s both;\n\n  @keyframes fadeOut {\n    from {\n      opacity: 1;\n      transform: translate3d(0, 0, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(0, -20%, 0);\n      visibility: hidden;\n    }\n  }\n}\n";

exports.fadeIn = fadeIn;
exports.fadeOut = fadeOut;
//# sourceMappingURL=index.js.map
